/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {ClientDashboardPage} from './pages/ClientDashboardPage'

export const ClientLayout: FC = () => <ClientDashboardPage />
